// TODO: From App New
<template>
  <b-card>
    <template #header>
      <div class="d-flex justify-content-between align-items-start w-100">
        <div>
          <h5 class="mb-0">
            Semua Brand
          </h5>
          <small class="text-muted">Daftar lengkap brand yang tersedia</small>
        </div>
        <b-badge
          variant="light-primary"
          class="flex-shrink-0"
        >
          {{ allBrands.length }} Brand
        </b-badge>
      </div>
    </template>

    <!-- Search Input -->
    <div class="mb-2">
      <b-input-group class="input-group-merge position-relative">
        <b-input-group-prepend is-text>
          <feather-icon icon="SearchIcon" />
        </b-input-group-prepend>

        <b-form-input
          v-model="searchKeyword"
          placeholder="Cari brand..."
          @input="handleSearch"
        />

        <b-input-group-append
          v-if="searchKeyword"
          is-text
          class="cursor-pointer"
          @click="resetSearch"
        >
          <feather-icon icon="XIcon" />
        </b-input-group-append>
      </b-input-group>
    </div>

    <!-- Loading State -->
    <div
      v-if="loading"
      class="brand-list d-flex align-items-center justify-content-center"
    >
      <div class="text-center py-4">
        <b-spinner variant="primary" />
        <p class="text-muted mt-2 mb-0">
          Memuat brands...
        </p>
      </div>
    </div>

    <!-- Brand List -->
    <div
      v-else-if="filteredBrands.length > 0"
      class="brand-list"
    >
      <div
        v-for="brand in filteredBrands"
        :key="brand.id"
        class="brand-item d-flex align-items-center p-2 border rounded mb-1"
      >
        <!-- Brand Image -->
        <div class="brand-image mr-3">
          <b-avatar
            :src="brand.image_url"
            :text="brand.name.charAt(0)"
            size="40"
            variant="light-secondary"
          />
        </div>

        <!-- Brand Info -->
        <div class="flex-grow-1">
          <h6 class="mb-0">
            {{ brand.name }}
          </h6>
          <small class="text-muted">{{ brand.slug }}</small>
        </div>

        <!-- Select Button -->
        <b-button
          size="sm"
          :variant="isBrandSelected(brand) ? 'outline-primary' : 'primary'"
          @click="$emit('toggle-brand', brand)"
        >
          {{ isBrandSelected(brand) ? 'Terpilih' : 'Pilih' }}
        </b-button>
      </div>
    </div>

    <!-- Empty State -->
    <div
      v-else
      class="brand-list d-flex align-items-center justify-content-center"
    >
      <div class="text-center py-4">
        <feather-icon
          icon="SearchIcon"
          size="48"
          class="text-muted mb-2"
        />
        <p class="text-muted mb-0">
          Tidak ada brand yang ditemukan
        </p>
        <small class="text-muted">
          Coba kata kunci yang berbeda
        </small>
      </div>
    </div>

    <!-- Pagination -->
    <div
      v-if="totalBrands > 0"
      class="mt-2 px-1"
    >
      <b-form-row class="align-items-center mb-1">
        <!-- Per page selector -->
        <b-col cols="auto">
          <small class="text-muted">Rows per page:</small>
        </b-col>
        <b-col cols="auto">
          <b-form-select
            :value="perPage"
            :options="perPageOptions"
            size="sm"
            @input="changePerPage"
          />
        </b-col>

        <!-- Row count display -->
        <b-col
          v-if="totalBrands > 0"
          cols="auto"
          class="mx-1"
        >
          <small class="text-muted">
            {{ startRowNumber }}-{{ endRowNumber }} of {{ totalBrands }}
          </small>
        </b-col>

        <!-- Pagination component -->
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalBrands"
            :per-page="perPage"
            align="right"
            size="sm"
            class="mb-0"
          />
        </b-col>
      </b-form-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BBadge,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormInput,
  BAvatar,
  BButton,
  BSpinner,
  BPagination,
  BFormRow,
  BCol,
  BFormSelect,
} from 'bootstrap-vue'

export default {
  name: 'SaleBrandsAll',
  components: {
    BCard,
    BBadge,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormInput,
    BAvatar,
    BButton,
    BSpinner,
    BPagination,
    BFormRow,
    BCol,
    BFormSelect,
  },
  props: {
    allBrands: {
      type: Array,
      default: () => [],
    },
    selectedBrands: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle-brand'],
  data() {
    return {
      searchKeyword: '',
      // Pagination
      perPage: 10,
      currentPage: 1,
      perPageOptions: [
        { value: 5, text: 5 },
        { value: 10, text: 10 },
        { value: 20, text: 20 },
        { value: 50, text: 50 },
      ],
    }
  },
  computed: {
    searchedBrands() {
      if (!this.searchKeyword) {
        return this.allBrands
      }

      const keyword = this.searchKeyword.toLowerCase()
      return this.allBrands.filter(brand => brand.name.toLowerCase().includes(keyword)
        || brand.slug.toLowerCase().includes(keyword))
    },
    totalBrands() {
      return this.searchedBrands.length
    },
    filteredBrands() {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      return this.searchedBrands.slice(start, end)
    },
    startRowNumber() {
      if (this.totalBrands === 0) return 0
      return (this.currentPage - 1) * this.perPage + 1
    },
    endRowNumber() {
      const end = this.currentPage * this.perPage
      return end > this.totalBrands ? this.totalBrands : end
    },
  },
  methods: {
    handleSearch() {
      // Reset to first page when search
      this.currentPage = 1
    },
    resetSearch() {
      this.searchKeyword = ''
      this.currentPage = 1
    },
    changePerPage(perPage) {
      this.perPage = perPage
      this.currentPage = 1 // Reset to first page
    },
    isBrandSelected(brand) {
      return this.selectedBrands.some(selected => selected.id === brand.id)
    },
  },
}
</script>

<style scoped>
.feather-icon {
  opacity: 0.5;
}

.cursor-pointer {
  cursor: pointer;
}

/* .brand-list {
  max-height: 400px;
  overflow-y: auto;
} */

.brand-item {
  transition: all 0.2s ease;
}
</style>
